import request from '@/utils/request';
import {
  setStore,
  getStore,
} from '@/utils/store'
const projectName = '/api/blade-platform';

const robotsManage = {
    state: {
        robotsManage_faqLibrary_ComponentName: getStore({ name: 'robotsManage_faqLibrary_ComponentName' }) || 'basicPage',
        robotsManage_faqRecord_ComponentName: getStore({ name: 'robotsManage_faqRecord_ComponentName' }) || 'basicPage',
        robotsManage_feedbackList_ComponentName: getStore({ name: 'robotsManage_feedbackList_ComponentName' }) || 'basicPage',
        robotsManage_funcSuggestion_ComponentName: getStore({ name: 'robotsManage_funcSuggestion_ComponentName' }) || 'basicPage',
    },
    mutations: {
        SET_robotsManage_faqLibrary_ComponentName: (state, robotsManage_faqLibrary_ComponentName) => {
            state.robotsManage_faqLibrary_ComponentName = robotsManage_faqLibrary_ComponentName
            setStore({
                name: 'robotsManage_faqLibrary_ComponentName',
                content: state.robotsManage_faqLibrary_ComponentName,
                type: 'session'
            })
        },
        SET_robotsManage_faqRecord_ComponentName: (state, robotsManage_faqRecord_ComponentName) => {
            state.robotsManage_faqRecord_ComponentName = robotsManage_faqRecord_ComponentName
            setStore({
                name: 'robotsManage_faqRecord_ComponentName',
                content: state.robotsManage_faqRecord_ComponentName,
                type: 'session'
            })
        },
        SET_robotsManage_feedbackList_ComponentName: (state, robotsManage_feedbackList_ComponentName) => {
            state.robotsManage_feedbackList_ComponentName = robotsManage_feedbackList_ComponentName
            setStore({
                name: 'robotsManage_feedbackList_ComponentName',
                content: state.robotsManage_feedbackList_ComponentName,
                type: 'session'
            })
        },
        SET_robotsManage_funcSuggestion_ComponentName: (state, robotsManage_funcSuggestion_ComponentName) => {
            state.robotsManage_funcSuggestion_ComponentName = robotsManage_funcSuggestion_ComponentName
            setStore({
                name: 'robotsManage_funcSuggestion_ComponentName',
                content: state.robotsManage_funcSuggestion_ComponentName,
                type: 'session'
            })
        }
    },
    actions: {
        // 【机器人】获取机器人分类选择栏
        questionTypeList(actions) {
            return request({
                url: `${projectName}/questionType/list`,
                method: 'get'
            })
        },
        // 【机器人】新增或者修改机器人分类
        saveOrUpdate(actions, data) {
            return request({
                url: `${projectName}/questionType/saveOrUpdate`,
                method: 'post',
                data,
            })
        },
        // 【机器人】删除问题
        removeFAQ(actions, data) {
            return request({
                url: `${projectName}/aiquestion/remove`,
                method: 'post',
                data,
            })
        },
        // 【机器人】保存或者修改问题
        saveFAQ(actions, data) {
            return request({
                url: `${projectName}/aiquestion/save`,
                method: 'post',
                data,
            })
        },
        // 【机器人】删除机器人分类
        removeFAQType(actions, data) {
            return request({
                url: `${projectName}/questionType/remove`,
                method: 'post',
                data,
            })
        },
        // 【机器人】问题库列表
        aiquestionList(actions, data) {
            return request({
                url: `${projectName}/aiquestion/list`,
                method: 'post',
                data,
            })
        },
        // 【机器人】机器人提问记录列表
        questionQuizList(actions, data) {
            return request({
                url: `${projectName}/questionQuiz/list`,
                method: 'post',
                data,
            })
        },
        // 【机器人】机器人提问记录删除
        questionQuizRemove(actions, data) {
            return request({
                url: `${projectName}/questionQuiz/remove`,
                method: 'post',
                data,
            })
        },
        // 【机器人】功能建议列表
        proposeList(actions, data) {
            return request({
                url: `${projectName}/question/propose/list`,
                method: 'post',
                data,
            })
        },
        // 【机器人】功能建议删除
        proposeRemove(actions, data) {
            return request({
                url: `${projectName}/question/propose/remove`,
                method: 'post',
                data,
            })
        },
        // 【机器人】异常反馈列表
        feedBackList(actions, data) {
            return request({
                url: `${projectName}/question/feedBack/list`,
                method: 'post',
                data,
            })
        },
        // 【机器人】异常反馈删除
        feedBackRemove(actions, data) {
            return request({
                url: `${projectName}/question/feedBack/remove`,
                method: 'post',
                data,
            })
        },
        // 【机器人】修改异常类型
        updateQuestionScene(actions, data) {
            return request({
                url: `${projectName}/questionScene/update`,
                method: 'post',
                data,
            })
        },
        // 【机器人】异常类型
        getQuestionSceneList(actions, data) {
            return request({
                url: `${projectName}/questionScene/list`,
                method: 'get'
            })
        },
    }
}
export default robotsManage
